import { CategoryType } from "../store/slice/productsSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

interface ProductsParams {
  category?: string;
  subcategory?: string;
}

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (params: ProductsParams, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/products`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        params: {
          limit: 50,
          ...(params.category ? { category: params.category } : {}),
          ...(params.subcategory ? { subcategory: params.subcategory } : {}),
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getProduct = createAsyncThunk(
  "products/getProduct",
  async (params: { code: string }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/products/${params.code}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getProductStock = createAsyncThunk(
  "products/getProductStock",
  async (params: { code: string }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `${API_URL}/products/${params.code}/stock`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data?.[0]?.quantity;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getProductNotice = createAsyncThunk(
  "products/getProductNotice",
  async (params: { code: string; type: "fs" | "ft" }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `${API_URL}/products/${params.code}/file`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          params: { type: params.type },
        }
      );
      return { type: params.type, url: response.data.url };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getCategories = createAsyncThunk(
  "products/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/products/categories`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const referenceOrder = [
        "dechets",
        "ouate",
        "chr",
        "chimie",
        "materiel",
        "vitrerie",
        "chariots",
        "brosserie",
        "ampoules",
        "protection",
        "tapis",
        "essuyage",
      ];
      const formattedTab = (response.data as CategoryType[])
        .map((item) => ({
          ...item,
          subcategories: item.subcategories.map((subcategory) => ({
            ...subcategory,
            name: `${subcategory.name.charAt(0).toUpperCase()}${subcategory.name
              .slice(1)
              .toLowerCase()}`,
          })),
        }))
        .sort((a, b) => {
          const getOrderIndex = (name: string) => {
            for (let i = 0; i < referenceOrder.length; i++) {
              if (name.toLowerCase().includes(referenceOrder[i])) {
                return i;
              }
            }
            return -1;
          };
          const aIndex = getOrderIndex(a.name);
          const bIndex = getOrderIndex(b.name);

          return aIndex - bIndex;
        });
      return formattedTab;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Erreur lors de la récupération des catégories"
      );
    }
  }
);
